import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./ScrollTextSection.css"; // Importăm CSS-ul separat

gsap.registerPlugin(ScrollTrigger);

const ScrollTextSection = () => {
  const sectionRef = useRef(null);
  const wordsRef = useRef([]);

  useEffect(() => {
    wordsRef.current.forEach((word, index) => {
      gsap.fromTo(
        word,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            end: "bottom 60%",
            toggleActions: "play none none reverse",
          },
          delay: index * 0.2,
        }
      );
    });
  }, []);

  return (
    <section ref={sectionRef} className="scroll-text-section">
      <div className="scroll-text-container">
        <h1 className="scroll-line black">
          <span ref={(el) => (wordsRef.current[0] = el)}>Stil.</span>{" "}
          <span ref={(el) => (wordsRef.current[1] = el)}></span>
        </h1>
        <h1 className="scroll-line black">
          <span ref={(el) => (wordsRef.current[2] = el)}>Confort.</span>
        </h1>
        <h1 className="scroll-line white">
          <span ref={(el) => (wordsRef.current[3] = el)}>Calitate.</span>
        </h1>
      </div>
      <div className="scroll-line-divider"></div>
    </section>
  );
};

export default ScrollTextSection;
